import { CryptoAndUsdPrices, CryptoAndUsdPricesSkeleton } from "@/app/price"
import type { BidItem } from "@anaconda/core/bid/types"
import { Trans } from "@lingui/react/macro"
import { Skeleton } from "@rarible_int/anaconda_ui_components"
import { Action } from "./action"
import { HeaderCell } from "./cells"
import { BidEntity, MiniatureSkeleton } from "./miniature"

interface Column {
  Header: React.ComponentType
  Content: React.ComponentType<BidItem>
  Skeleton: React.ComponentType
}

export const COLUMNS: Column[] = [
  {
    Header: () => (
      <HeaderCell className="w-[250px] md:w-[350px]">
        <Trans>Collection / Item</Trans>
      </HeaderCell>
    ),
    Content: (bidItem) => <BidEntity bid={bidItem} />,
    Skeleton: MiniatureSkeleton,
  },
  {
    Header: () => (
      <HeaderCell className="w-[150px] md:w-[180px]">
        <Trans>Floor Price</Trans>
      </HeaderCell>
    ),
    Content: (bidItem) =>
      bidItem.collectionFloorPrice ? (
        <CryptoAndUsdPrices {...bidItem.collectionFloorPrice} />
      ) : (
        <span>—</span>
      ),
    Skeleton: () => <CryptoAndUsdPricesSkeleton />,
  },
  {
    Header: () => (
      <HeaderCell className="w-[150px] md:w-[180px]">
        <Trans>Offer Price</Trans>
      </HeaderCell>
    ),
    Content: (bidItem) => <CryptoAndUsdPrices {...bidItem.bid.price} />,
    Skeleton: () => <CryptoAndUsdPricesSkeleton />,
  },
  {
    Header: () => (
      <HeaderCell className="w-[150px] md:w-[180px]">
        <Trans>Actions</Trans>
      </HeaderCell>
    ),
    Content: (bidItem) => (
      <div className="flex justify-end">
        <Action bidItem={bidItem} />
      </div>
    ),
    Skeleton: () => (
      <div className="flex justify-end">
        <Skeleton className="h-9 w-[75px]" />
      </div>
    ),
  },
]
